import { Spinner } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import { mailTrackingConfirmation } from 'app/modules/mail-history/core/requests';
import {
  Button,
  Card,
  Container,
  Description,
  IconWrapper,
  Title,
} from 'app/modules/mail-history/core/styles';

import { usePageGoBack } from 'app/helpers/utils';

import { PATH } from 'app/constants/path';

import { ReactComponent as CheckIcon } from 'app/assets/icons/icon-tick.svg';
import { ReactComponent as AlertIcon } from 'app/assets/icons/warning-2.svg';

const ConfirmEmail = () => {
  const params = useParams();
  const goBack = usePageGoBack(PATH.MAIL_HISTORY);

  const { status: queryStatus } = useQuery({
    queryKey: ['confirm-email', params.id],
    queryFn: () => mailTrackingConfirmation(params.id),
    retry: false,
    enabled: !!params.id,
  });

  const iconMap: Record<typeof queryStatus, JSX.Element> = {
    loading: <Spinner animation="border" variant="primary" />,
    success: <CheckIcon />,
    error: <AlertIcon />,
    idle: <></>,
  };

  const contentMap: Record<typeof queryStatus, JSX.Element> = {
    loading: (
      <>
        <Title>Confirming Your Email...</Title>
        <Description>
          Please wait while we verify your email address. This should only take a moment.
        </Description>
      </>
    ),
    success: (
      <>
        <Title>Email Confirmed Successfully!</Title>
        <Button onClick={goBack}>Go back</Button>
      </>
    ),
    error: (
      <>
        <Title>Confirmation Failed</Title>
        <Button onClick={goBack}>Go back</Button>
      </>
    ),
    idle: <></>,
  };

  return (
    <Container>
      <Card>
        <IconWrapper status={queryStatus as any}>{iconMap[queryStatus]}</IconWrapper>
        {contentMap[queryStatus]}
      </Card>
    </Container>
  );
};

export default ConfirmEmail;
